import "../App.css";
import { middle_3b } from "../svgs";
import { WindowContext } from "../App";

import {
  wl2,
  wr2,
  left_2_1,
  right_2_1,
  bottom_2_1,
  left_3,
  right_3,
  middle_3,
  left_3_1,
  middle_3_1,
  right_3_1,
  bottom_3b_2,
  left_3b_b,
  middle_3b_b,
  right_3b_b,
  bottom_3b,
  left_3b,
  right_3b,
} from "../svgs";

import { useContext, useState } from "react";
import { InputBox } from "./InputBox";
import { useTranslation } from "react-i18next";

function Mountings() {
  // {"2w":"left","2wfb":"left","3w":"left","3wfb":"left","3wAsync":"left","3wfbAsync":"left"}
  const [selectedIcons, setSelectedIcons] = useState({
    "2w": "left",
    "2wfb": "left",
    "3w": "left",
    "3wfb": "left",
    "3wAsync": "left",
    "3wfbAsync": "left",
  });
  let currentMountingIcons = [];
  const { currentWindow } = useContext(WindowContext);
  const { t } = useTranslation();

  window["setSelectedIconMounting"] = function () {
    setSelectedIconMounting("left");
  };

  function setSelectedIconMounting(wing) {
    switch (currentWindow) {
      case "2w":
        setSelectedIcons(() => ({ ...selectedIcons, "2w": wing }));
        break;
      case "2wfb":
        setSelectedIcons(() => ({ ...selectedIcons, "2wfb": wing }));
        break;
      case "3w":
        setSelectedIcons(() => ({ ...selectedIcons, "3w": wing }));
        break;
      case "3wfb":
        setSelectedIcons(() => ({ ...selectedIcons, "3wfb": wing }));
        break;
      case "3wAsync":
        setSelectedIcons(() => ({ ...selectedIcons, "3wAsync": wing }));
        break;
      case "3wfbAsync":
        setSelectedIcons(() => ({ ...selectedIcons, "3wfbAsync": wing }));
        break;
      default:
    }
  }

  // 2w, 2wfb, 3wfb, 3w, 3wAsync, 3wfbAsync
  switch (currentWindow) {
    case "2w":
      currentMountingIcons = [wl2, "", wr2, ""];
      break;
    case "2wfb":
      currentMountingIcons = [left_2_1, "", right_2_1, bottom_2_1];
      break;
    case "3w":
      currentMountingIcons = [left_3, middle_3, right_3, ""];
      break;
    case "3wfb":
      currentMountingIcons = [left_3b, middle_3b, right_3b, bottom_3b];
      break;
    case "3wAsync":
      currentMountingIcons = [left_3_1, middle_3_1, right_3_1, ""];
      break;
    case "3wfbAsync":
      currentMountingIcons = [left_3b_b, middle_3b_b, right_3b_b, bottom_3b_2];
      break;
    default:
  }

  return (
    <>
      <div className="panel-section">
        <div className="wing-picker">
          <div className="section-header section">
            <span>{t("mountings")}</span>
            <section>
              <img
                alt=""
                // src={left_2_1}
                src={currentMountingIcons[0]}
                id="left-wing"
                className="wings"
                onClick={() => {
                  setSelectedIconMounting("left");
                }}
                style={{
                  height: "24px",
                  opacity: selectedIcons[currentWindow] === "left" ? 1 : 0.44,
                  boxShadow:
                    selectedIcons[currentWindow] === "left"
                      ? "2px 2px 4px 1px #00244777"
                      : "",
                }}
              />
              <img
                alt=""
                //src={bottom_2_1}
                src={currentMountingIcons[1]}
                id="middle-wing"
                className="wings"
                onClick={() => {
                  setSelectedIconMounting("middle");
                }}
                style={{
                  height: "24px",
                  opacity: selectedIcons[currentWindow] === "middle" ? 1 : 0.44,
                  boxShadow:
                    selectedIcons[currentWindow] === "middle"
                      ? "2px 2px 4px 1px #00244777"
                      : "",
                }}
              />
              <img
                alt=""
                // src={right_2_1}
                src={currentMountingIcons[2]}
                id="right-wing"
                className="wings"
                onClick={() => {
                  setSelectedIconMounting("right");
                }}
                style={{
                  height: "24px",
                  opacity: selectedIcons[currentWindow] === "right" ? 1 : 0.44,
                  boxShadow:
                    selectedIcons[currentWindow] === "right"
                      ? "2px 2px 4px 1px #00244777"
                      : "",
                }}
              />
              <img
                alt=""
                // src={bottom_2_1}
                src={currentMountingIcons[3]}
                id="bottom-wing"
                className="wings"
                onClick={() => {
                  setSelectedIconMounting("bottom");
                }}
                style={{
                  height: "24px",
                  opacity: selectedIcons[currentWindow] === "bottom" ? 1 : 0.44,
                  boxShadow:
                    selectedIcons[currentWindow] === "bottom"
                      ? "2px 2px 4px 1px #00244777"
                      : "",
                }}
              />
            </section>
          </div>

          <div className="line" style={{ marginTop: 5 + "px" }}></div>
        </div>

        <div
          className="cleanInput"
          id="panel-mountings-top"
          style={{ display: "flex", flexDirection: "column" }}
        >
          <section>
            {/* <CustomInputBox
              tittle={"Horizontal"}
              // id={"horizontal-mountings"}
              type={"number"}
              placeholder={0}
              step={1}
              min={0}
              max={10}
              editable={true}
            /> */}
            <InputBox
              // id={"teste"}
              id={"horizontal-mountings"}
              tittle={t("horizontal")}
              decimalPlaces={0}
              step={1}
              iniValue={0}
              min={0}
              max={4}
              // unit={"cm"}
              editable={true}
            />
          </section>
          <section>
            <InputBox
              // id={"teste"}
              id={"vertical-mountings"}
              tittle={t("vertical")}
              decimalPlaces={0}
              step={1}
              iniValue={0}
              min={0}
              max={4}
              // unit={"cm"}
              editable={true}
            />
            {/* <CustomInputBox
              tittle={"Vertical"}
              id={"vertical-mountings"}
              type={"number"}
              placeholder={0}
              step={1}
              min={0}
              max={10}
              editable={true}
            /> */}
          </section>
        </div>
        <div  className=""  id="panel-mountings-bottom">
          <span style={{maxWidth: "300px"}} >{t("bottom_mountings")}</span>
          <div>
            <section>
              <input id="checkboxVertical" type="checkbox" />
              <label>{t("vertical")}</label>
            </section>
            <section>
              <input id="checkboxMiddle" type="checkbox" />
              <label>{t("middle")}</label>
            </section>
            <section style={{ display: "none" }}>
              <input id="checkboxHorizontal" type="checkbox" />
              <label>{t("horizontal")}</label>
            </section>
          </div>
        </div>
      </div>
    </>
  );
}

export default Mountings;
